import React from "react";
import { useParams, Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { get } from "../lib/api";
import { Seo, breadcrumbJsonLd } from "../lib/seo";
import { Section, SectionHead, Breadcrumb, Button, Badge } from "../components/ui";
import { DataTable } from "../components/marketing";
import { useReveal } from "../lib/useReveal";

export function ChannelsIndex() {
  const { data: channels } = useQuery({ queryKey: ["channels"], queryFn: () => get("/channels-directory") });
  useReveal(channels);
  return (
    <>
      <Seo title="Channels" path="/features/channels/" description="Connect WhatsApp, Instagram, Messenger, Telegram, Email, web chat and SMS — one AI sales agent, one inbox, seven live channels." />
      <Section>
        <SectionHead label="Channels" title="One agent. Every channel your buyers use." />
        <div className="mt-8">{channels && <DataTable caption="Channels" head={["Channel","How it connects","What the AI does","Availability"]} rows={channels.map(c=>[<Link key={c.slug} to={`/features/channels/${c.slug}/`} className="link">{c.name}</Link>, c.connect, c.does, c.availability])} />}</div>
      </Section>
    </>
  );
}

export function ChannelDetail() {
  const { slug } = useParams();
  const { data: channels } = useQuery({ queryKey: ["channels"], queryFn: () => get("/channels-directory") });
  const c = (channels || []).find((x) => x.slug === slug);
  const dev = c && c.availability !== "Live";
  return (
    <>
      <Seo title={c ? `${c.name}` : "Channel"} path={`/features/channels/${slug}/`} description={c ? `Use BloomCONNECT on ${c.name}. ${c.does}. Connects via ${c.connect.toLowerCase()}.` : ""} jsonLd={breadcrumbJsonLd([{name:"Features",path:"/features/"},{name:"Channels",path:"/features/channels/"},{name:c?.name||slug,path:`/features/channels/${slug}/`}])} />
      <Section>
        <Breadcrumb items={[{name:"Features",path:"/features/"},{name:"Channels",path:"/features/channels/"},{name:c?.name||slug}]} />
        {c ? (
          <div className="mt-6 max-w-prose">
            <div className="flex items-center gap-3">{dev && <Badge>In development</Badge>}</div>
            <h1 className="mt-3 text-4xl md:text-5xl tracking-tight text-ink-950">BloomCONNECT on {c.name}.</h1>
            <p className="mt-5 text-lg text-ink-600">{c.does}. Connects via {c.connect.toLowerCase()}.</p>
            <dl className="mt-8 divide-y divide-line border-y border-line">
              <div className="flex justify-between py-3"><dt className="text-ink-600">How it connects</dt><dd className="font-mono text-sm text-ink-800">{c.connect}</dd></div>
              <div className="flex justify-between py-3"><dt className="text-ink-600">What the AI can do</dt><dd className="text-sm text-ink-800 text-right max-w-xs">{c.does}</dd></div>
              <div className="flex justify-between py-3"><dt className="text-ink-600">Availability</dt><dd className="font-mono text-sm text-ink-800">{c.availability}</dd></div>
            </dl>
            {!dev && <div className="mt-8"><Button to="/pricing/" variant="primary" size="lg" data-testid="channels-see-pricing-btn">See Pricing</Button></div>}
          </div>
        ) : <p className="mt-8 text-ink-400">Channel not found.</p>}
      </Section>
    </>
  );
}
